import { Avatar } from '../../UI/elements/Avatar';
import { getRandomFromInterval } from '../../utils/MathUtils';

export class AvatarManager {
    private static _instance: AvatarManager;
    private connectedFriendsAvatars: Avatar[] = [];

    constructor() {
        FBInstant.player.getConnectedPlayersAsync().then((players: any) => {
            if (players) {
                players.forEach((player: any) => {
                    const avatar: Avatar = new Avatar(player.$1.photo, false, player.$1.id);
                    this.connectedFriendsAvatars.push(avatar);
                });
            }
        });
    }

    public static getInstance(): AvatarManager {
        return this._instance || (this._instance = new this());
    }

    public getRandomAvatar(): Avatar {
        return this.connectedFriendsAvatars[getRandomFromInterval(0, this.connectedFriendsAvatars.length - 1)];
    }

    public getEmptyAvatar(): Avatar {
        return new Avatar(null, false);
    }
}